<style>
  .my-pagination /deep/ .ngx-pagination {
    text-align: center;

  }
</style>


<div class="container">
  <nav aria-label="breadcrumb" class="breadCust">
    <ol class="breadcrumb">
      <li class="breadcrumb-item"><a routerLink="/corporate/home">Home</a></li>
      <li class="breadcrumb-item"><a routerLink="/corporate/subscriptionModule">Subscription Module</a></li>
    <li class="breadcrumb-item active">License Bundle Assign</li>
    </ol>
  </nav>
</div>


<div class="container mt-2 themeTblReso">
  <div class="assignFilterBar">
    <div class="filterItem">
      <select class="form-control formstyle" [ngModel]="selectedCompany" (ngModelChange)="onCompanyChange($event)">
        <option value="0">Please select company</option>
        <option *ngFor="let userObj of getCompanyobj" value={{userObj.customer_id}}>
          {{userObj.customer_company_name}}
        </option>
      </select>
    </div>
    <div class="filterItem filterSearch">
      <div class="input-group">
        <div class="input-group-prepend">
          <span class="input-group-text cyan lighten-2" id="basic-text1"><i class="fa fa-search text-white"
              aria-hidden="true"></i></span>
        </div>
        <input class="form-control" type="text" placeholder="Search" aria-label="Search" [(ngModel)]="text">
      </div>
    </div>
    <div class="filterAction">
      <input type="button" value="Reset" class="custbtn-outline" (click)="resetFilters()" />
      <input type="button" value="Assign Bundle" class="custbtn" *ngIf="isWrite" routerLink="/corporate/license-bundle-assign" />
    </div>
  </div>

<div class="tblPrt">
  <table class="mt-1 bdrStCustom" width="100%" cellpadding="0" cellspacing="0"> 
    <tr>
      <!-- <th>Theme Id</th> -->
      <th>Full Name</th>
      <th>Email ID</th>
      <th>Bundle Name</th>    
      
      <th *ngIf="isEdit || isDelete">Actions</th>
    </tr>

    <tr *ngFor="let obj of bundleData | filter:text | orderBy:colname:ord | paginate:{itemsPerPage:10,currentPage:cp }">
      <!-- <td>{{obj.get_master_module_item_fun.moduleitemid}}</td> -->
      <td >{{obj.user_fname}} {{obj.user_lname}}</td>     
      <td>{{obj.user_email_primary}}</td>
      <td  >{{obj.bundle_name}}</td>
     
      <td  width="5"  *ngIf="isEdit || isDelete">
        <div class="actBtn">        
        <span class="fa fa-trash mr-1 cursor"
        (click)="removeBundle(obj.user_ds_id)"placement="bottom" *ngIf="isDelete" ngbTooltip="Remove"></span>
       
      </div>
      </td>
    </tr>


</table>
<pagination-controls class="my-pagination mt-2" (pageChange)="cp=$event"></pagination-controls>
</div>

</div>